var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    [
      _c(
        "b-container",
        { attrs: { fluid: "" } },
        [
          _c(
            "b-jumbotron",
            [
              _c("template", { slot: "header" }, [
                _c(
                  "p",
                  { staticClass: "text-align-center header-font-style" },
                  [
                    _vm._v(
                      "\n                    " +
                        _vm._s(_vm.$store.state.report.userEdited.fullname) +
                        "(" +
                        _vm._s(_vm.$store.state.report.userEdited.flag) +
                        ")\n                    " +
                        _vm._s(_vm.$store.state.report.userEdited.nricFin) +
                        "\n                    "
                    ),
                    !!_vm.$store.state.authUser &&
                    _vm.$store.state.authUser.flag == "Admin"
                      ? _c(
                          "b-button",
                          {
                            attrs: { variant: "danger" },
                            on: {
                              click: function($event) {
                                _vm.popRemoveModal($event.target)
                              }
                            }
                          },
                          [
                            _vm._v(
                              "\n                        Remove User\n                    "
                            )
                          ]
                        )
                      : _vm._e()
                  ],
                  1
                )
              ]),
              _c(
                "b-card",
                { attrs: { "border-variant": "dark", "bg-variant": "light" } },
                [
                  _c(
                    "b-row",
                    { staticClass: "user-edited-panel" },
                    [
                      _c(
                        "b-col",
                        { staticClass: "text-align-right", attrs: { sm: "3" } },
                        [_vm._v("User Name: ")]
                      ),
                      _c(
                        "b-col",
                        { attrs: { sm: "9" } },
                        [
                          _c("b-form-input", {
                            model: {
                              value: _vm.userEdited.username,
                              callback: function($$v) {
                                _vm.$set(_vm.userEdited, "username", $$v)
                              },
                              expression: "userEdited.username"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "b-row",
                    { staticClass: "user-edited-panel" },
                    [
                      _c(
                        "b-col",
                        { staticClass: "text-align-right", attrs: { sm: "3" } },
                        [_vm._v("Password: ")]
                      ),
                      _c(
                        "b-col",
                        { attrs: { sm: "9" } },
                        [
                          _c("b-form-input", {
                            attrs: { type: "text" },
                            model: {
                              value: _vm.userEdited.password,
                              callback: function($$v) {
                                _vm.$set(_vm.userEdited, "password", $$v)
                              },
                              expression: "userEdited.password"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "b-row",
                    { staticClass: "user-edited-panel" },
                    [
                      _c(
                        "b-col",
                        { staticClass: "text-align-right", attrs: { sm: "3" } },
                        [_vm._v("Identity Type: ")]
                      ),
                      _c(
                        "b-col",
                        { attrs: { sm: "9" } },
                        [
                          _c("b-form-select", {
                            attrs: { type: "text", options: _vm.idType },
                            model: {
                              value: _vm.userEdited.idType,
                              callback: function($$v) {
                                _vm.$set(_vm.userEdited, "idType", $$v)
                              },
                              expression: "userEdited.idType"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "b-row",
                    { staticClass: "user-edited-panel" },
                    [
                      _c(
                        "b-col",
                        { staticClass: "text-align-right", attrs: { sm: "3" } },
                        [_vm._v("Nric / Fin: ")]
                      ),
                      _c(
                        "b-col",
                        { attrs: { sm: "9" } },
                        [
                          _c("b-form-input", {
                            attrs: { type: "text" },
                            model: {
                              value: _vm.userEdited.nricFin,
                              callback: function($$v) {
                                _vm.$set(_vm.userEdited, "nricFin", $$v)
                              },
                              expression: "userEdited.nricFin"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "b-row",
                    { staticClass: "user-edited-panel" },
                    [
                      _c(
                        "b-col",
                        { staticClass: "text-align-right", attrs: { sm: "3" } },
                        [_vm._v("D.O.B: ")]
                      ),
                      _c(
                        "b-col",
                        { attrs: { sm: "9" } },
                        [
                          _c("b-form-input", {
                            attrs: { type: "date" },
                            model: {
                              value: _vm.userEdited.dateOfBirth,
                              callback: function($$v) {
                                _vm.$set(_vm.userEdited, "dateOfBirth", $$v)
                              },
                              expression: "userEdited.dateOfBirth"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "b-row",
                    { staticClass: "user-edited-panel" },
                    [
                      _c(
                        "b-col",
                        { staticClass: "text-align-right", attrs: { sm: "3" } },
                        [_vm._v("Name: ")]
                      ),
                      _c(
                        "b-col",
                        { attrs: { sm: "9" } },
                        [
                          _c("b-form-input", {
                            attrs: { type: "text" },
                            model: {
                              value: _vm.userEdited.fullname,
                              callback: function($$v) {
                                _vm.$set(_vm.userEdited, "fullname", $$v)
                              },
                              expression: "userEdited.fullname"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "b-row",
                    { staticClass: "user-edited-panel" },
                    [
                      _c(
                        "b-col",
                        { staticClass: "text-align-right", attrs: { sm: "3" } },
                        [_vm._v("Company: ")]
                      ),
                      _c(
                        "b-col",
                        { attrs: { sm: "9" } },
                        [
                          _c("b-form-input", {
                            model: {
                              value: _vm.userEdited.companyName,
                              callback: function($$v) {
                                _vm.$set(_vm.userEdited, "companyName", $$v)
                              },
                              expression: "userEdited.companyName"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm.$store.state.authUser.flag == "Admin"
                    ? _c(
                        "b-row",
                        { staticClass: "user-edited-panel" },
                        [
                          _c(
                            "b-col",
                            {
                              staticClass: "text-align-right",
                              attrs: { sm: "3" }
                            },
                            [_vm._v("Role: ")]
                          ),
                          _c(
                            "b-col",
                            { attrs: { sm: "9" } },
                            [
                              _c("b-form-select", {
                                attrs: { options: _vm.flagType },
                                model: {
                                  value: _vm.userEdited.flag,
                                  callback: function($$v) {
                                    _vm.$set(_vm.userEdited, "flag", $$v)
                                  },
                                  expression: "userEdited.flag"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _c(
                    "b-row",
                    { staticClass: "user-edited-panel" },
                    [
                      _c(
                        "b-col",
                        { staticClass: "text-align-right", attrs: { sm: "3" } },
                        [_vm._v("Contractor Email: ")]
                      ),
                      _c(
                        "b-col",
                        { attrs: { sm: "9" } },
                        [
                          _c("b-form-input", {
                            model: {
                              value: _vm.userEdited.conEmail,
                              callback: function($$v) {
                                _vm.$set(_vm.userEdited, "conEmail", $$v)
                              },
                              expression: "userEdited.conEmail"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c("br"),
                  _c(
                    "b-row",
                    [
                      _c(
                        "b-col",
                        { staticClass: "text-align-right" },
                        [
                          _c(
                            "b-btn",
                            {
                              attrs: {
                                block: "",
                                variant: "success",
                                size: "lg"
                              },
                              on: {
                                click: function($event) {
                                  _vm.editUserInfo()
                                }
                              }
                            },
                            [_vm._v("Update User Information")]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c("br"),
                  _c("br"),
                  _c(
                    "b-card",
                    {
                      staticClass: "working-profile-container",
                      attrs: {
                        header: "Working Profile",
                        "border-variant": "primary",
                        "header-bg-variant": "primary",
                        "header-text-variant": "white"
                      }
                    },
                    [
                      !!_vm.userEdited.workingProfile &&
                      !!_vm.$store.state.authUser &&
                      _vm.$store.state.authUser.flag == "Admin"
                        ? _c(
                            "div",
                            [
                              _c(
                                "b-row",
                                { staticClass: "user-edited-panel" },
                                [
                                  _c(
                                    "b-col",
                                    {
                                      staticClass: "text-align-right",
                                      attrs: { sm: "5" }
                                    },
                                    [_vm._v(" Work_Permit_number: ")]
                                  ),
                                  _c(
                                    "b-col",
                                    { attrs: { sm: "7" } },
                                    [
                                      _c("b-form-input", {
                                        attrs: { type: "text" },
                                        model: {
                                          value:
                                            _vm.userEdited.workingProfile[
                                              "Work_Permit_number"
                                            ],
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.userEdited.workingProfile,
                                              "Work_Permit_number",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "userEdited.workingProfile['Work_Permit_number']"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _c(
                                "b-row",
                                { staticClass: "user-edited-panel" },
                                [
                                  _c(
                                    "b-col",
                                    {
                                      staticClass: "text-align-right",
                                      attrs: { sm: "5" }
                                    },
                                    [_vm._v(" Work_Permit_Expiry: ")]
                                  ),
                                  _c(
                                    "b-col",
                                    { attrs: { sm: "7" } },
                                    [
                                      _c(
                                        "no-ssr",
                                        [
                                          _c("vue-ctk-date-time-picker", {
                                            attrs: {
                                              formatted: "DD-MM-YYYY",
                                              label: "Choose date",
                                              color: "#184167",
                                              "enable-button-validate": "",
                                              "disable-time": ""
                                            },
                                            model: {
                                              value:
                                                _vm.userEdited.workingProfile[
                                                  "Work_Permit_Expiry"
                                                ],
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.userEdited.workingProfile,
                                                  "Work_Permit_Expiry",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "userEdited.workingProfile['Work_Permit_Expiry']"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _c(
                                "b-row",
                                { staticClass: "user-edited-panel" },
                                [
                                  _c(
                                    "b-col",
                                    {
                                      staticClass: "text-align-right",
                                      attrs: { sm: "5" }
                                    },
                                    [_vm._v("> Good_Behaviour: ")]
                                  ),
                                  _c(
                                    "b-col",
                                    { attrs: { sm: "7" } },
                                    [
                                      _c(
                                        "no-ssr",
                                        [
                                          _c("vue-ctk-date-time-picker", {
                                            attrs: {
                                              formatted: "DD-MM-YYYY",
                                              label: "Choose date",
                                              color: "#184167",
                                              "enable-button-validate": "",
                                              "disable-time": ""
                                            },
                                            model: {
                                              value:
                                                _vm.userEdited.workingProfile[
                                                  "Good_Behaviour"
                                                ],
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.userEdited.workingProfile,
                                                  "Good_Behaviour",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "userEdited.workingProfile['Good_Behaviour']"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _c(
                                "b-row",
                                { staticClass: "user-edited-panel" },
                                [
                                  _c(
                                    "b-col",
                                    {
                                      staticClass: "text-align-right",
                                      attrs: { sm: "5" }
                                    },
                                    [_vm._v("> Warning: ")]
                                  ),
                                  _c(
                                    "b-col",
                                    { attrs: { sm: "7" } },
                                    [
                                      _c(
                                        "no-ssr",
                                        [
                                          _c("vue-ctk-date-time-picker", {
                                            attrs: {
                                              formatted: "DD-MM-YYYY",
                                              label: "Choose date",
                                              color: "#184167",
                                              "enable-button-validate": "",
                                              "disable-time": ""
                                            },
                                            model: {
                                              value:
                                                _vm.userEdited.workingProfile[
                                                  "Warning"
                                                ],
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.userEdited.workingProfile,
                                                  "Warning",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "userEdited.workingProfile['Warning']"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _c(
                                "b-row",
                                { staticClass: "user-edited-panel" },
                                [
                                  _c(
                                    "b-col",
                                    {
                                      staticClass: "text-align-right",
                                      attrs: { sm: "5" }
                                    },
                                    [_vm._v("> Suspension: ")]
                                  ),
                                  _c(
                                    "b-col",
                                    { attrs: { sm: "7" } },
                                    [
                                      _c(
                                        "no-ssr",
                                        [
                                          _c("vue-ctk-date-time-picker", {
                                            attrs: {
                                              formatted: "DD-MM-YYYY",
                                              label: "Choose date",
                                              color: "#184167",
                                              "enable-button-validate": "",
                                              "disable-time": ""
                                            },
                                            model: {
                                              value:
                                                _vm.userEdited.workingProfile[
                                                  "Suspension"
                                                ],
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.userEdited.workingProfile,
                                                  "Suspension",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "userEdited.workingProfile['Suspension']"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _c(
                                "b-row",
                                { staticClass: "user-edited-panel" },
                                [
                                  _c(
                                    "b-col",
                                    {
                                      staticClass: "text-align-right",
                                      attrs: { sm: "5" }
                                    },
                                    [_vm._v("> Ban: ")]
                                  ),
                                  _c(
                                    "b-col",
                                    { attrs: { sm: "7" } },
                                    [
                                      _c(
                                        "no-ssr",
                                        [
                                          _c("vue-ctk-date-time-picker", {
                                            attrs: {
                                              formatted: "DD-MM-YYYY",
                                              label: "Choose date",
                                              color: "#184167",
                                              "enable-button-validate": "",
                                              "disable-time": ""
                                            },
                                            model: {
                                              value:
                                                _vm.userEdited.workingProfile[
                                                  "Ban"
                                                ],
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.userEdited.workingProfile,
                                                  "Ban",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "userEdited.workingProfile['Ban']"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _c(
                                "b-row",
                                { staticClass: "user-edited-panel" },
                                [
                                  _c(
                                    "b-col",
                                    {
                                      staticClass: "text-align-right",
                                      attrs: { sm: "5" }
                                    },
                                    [_vm._v("> SIC-IFW: ")]
                                  ),
                                  _c(
                                    "b-col",
                                    { attrs: { sm: "7" } },
                                    [
                                      _c(
                                        "no-ssr",
                                        [
                                          _c("vue-ctk-date-time-picker", {
                                            attrs: {
                                              formatted: "DD-MM-YYYY",
                                              label: "Choose date",
                                              color: "#184167",
                                              "enable-button-validate": "",
                                              "disable-time": ""
                                            },
                                            model: {
                                              value:
                                                _vm.userEdited.workingProfile[
                                                  "SIC_IFWO"
                                                ],
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.userEdited.workingProfile,
                                                  "SIC_IFWO",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "userEdited.workingProfile['SIC_IFWO']"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _c(
                                "b-row",
                                { staticClass: "user-edited-panel" },
                                [
                                  _c(
                                    "b-col",
                                    {
                                      staticClass: "text-align-right",
                                      attrs: { sm: "5" }
                                    },
                                    [_vm._v("> IFW_Supervisory_Skills_SSK: ")]
                                  ),
                                  _c(
                                    "b-col",
                                    { attrs: { sm: "7" } },
                                    [
                                      _c(
                                        "no-ssr",
                                        [
                                          _c("vue-ctk-date-time-picker", {
                                            attrs: {
                                              formatted: "DD-MM-YYYY",
                                              label: "Choose date",
                                              color: "#184167",
                                              "enable-button-validate": "",
                                              "disable-time": ""
                                            },
                                            model: {
                                              value:
                                                _vm.userEdited.workingProfile[
                                                  "IFW_Supervisory_Skills_SSK"
                                                ],
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.userEdited.workingProfile,
                                                  "IFW_Supervisory_Skills_SSK",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "userEdited.workingProfile['IFW_Supervisory_Skills_SSK']"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _c(
                                "b-row",
                                { staticClass: "user-edited-panel" },
                                [
                                  _c(
                                    "b-col",
                                    {
                                      staticClass: "text-align-right",
                                      attrs: { sm: "5" }
                                    },
                                    [_vm._v("> JSA_Training: ")]
                                  ),
                                  _c(
                                    "b-col",
                                    { attrs: { sm: "7" } },
                                    [
                                      _c(
                                        "no-ssr",
                                        [
                                          _c("vue-ctk-date-time-picker", {
                                            attrs: {
                                              formatted: "DD-MM-YYYY",
                                              label: "Choose date",
                                              color: "#184167",
                                              "enable-button-validate": "",
                                              "disable-time": ""
                                            },
                                            model: {
                                              value:
                                                _vm.userEdited.workingProfile[
                                                  "JSA_Training"
                                                ],
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.userEdited.workingProfile,
                                                  "JSA_Training",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "userEdited.workingProfile['JSA_Training']"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _c(
                                "b-row",
                                { staticClass: "user-edited-panel" },
                                [
                                  _c(
                                    "b-col",
                                    {
                                      staticClass: "text-align-right",
                                      attrs: { sm: "5" }
                                    },
                                    [_vm._v("> PTW_Training: ")]
                                  ),
                                  _c(
                                    "b-col",
                                    { attrs: { sm: "7" } },
                                    [
                                      _c(
                                        "no-ssr",
                                        [
                                          _c("vue-ctk-date-time-picker", {
                                            attrs: {
                                              formatted: "DD-MM-YYYY",
                                              label: "Choose date",
                                              color: "#184167",
                                              "enable-button-validate": "",
                                              "disable-time": ""
                                            },
                                            model: {
                                              value:
                                                _vm.userEdited.workingProfile[
                                                  "PTW_Training"
                                                ],
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.userEdited.workingProfile,
                                                  "PTW_Training",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "userEdited.workingProfile['PTW_Training']"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _c(
                                "b-row",
                                { staticClass: "user-edited-panel" },
                                [
                                  _c(
                                    "b-col",
                                    {
                                      staticClass: "text-align-right",
                                      attrs: { sm: "5" }
                                    },
                                    [_vm._v("> SBO_APP: ")]
                                  ),
                                  _c(
                                    "b-col",
                                    { attrs: { sm: "7" } },
                                    [
                                      _c(
                                        "no-ssr",
                                        [
                                          _c("vue-ctk-date-time-picker", {
                                            attrs: {
                                              formatted: "DD-MM-YYYY",
                                              label: "Choose date",
                                              color: "#184167",
                                              "enable-button-validate": "",
                                              "disable-time": ""
                                            },
                                            model: {
                                              value:
                                                _vm.userEdited.workingProfile[
                                                  "SBO_APP"
                                                ],
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.userEdited.workingProfile,
                                                  "SBO_APP",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "userEdited.workingProfile['SBO_APP']"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _c(
                                "b-row",
                                { staticClass: "user-edited-panel" },
                                [
                                  _c(
                                    "b-col",
                                    {
                                      staticClass: "text-align-right",
                                      attrs: { sm: "5" }
                                    },
                                    [_vm._v("> Lifting_Plan: ")]
                                  ),
                                  _c(
                                    "b-col",
                                    { attrs: { sm: "7" } },
                                    [
                                      _c(
                                        "no-ssr",
                                        [
                                          _c("vue-ctk-date-time-picker", {
                                            attrs: {
                                              formatted: "DD-MM-YYYY",
                                              label: "Choose date",
                                              color: "#184167",
                                              "enable-button-validate": "",
                                              "disable-time": ""
                                            },
                                            model: {
                                              value:
                                                _vm.userEdited.workingProfile[
                                                  "Lifting_Plan"
                                                ],
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.userEdited.workingProfile,
                                                  "Lifting_Plan",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "userEdited.workingProfile['Lifting_Plan']"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _c(
                                "b-row",
                                { staticClass: "user-edited-panel" },
                                [
                                  _c(
                                    "b-col",
                                    {
                                      staticClass: "text-align-right",
                                      attrs: { sm: "5" }
                                    },
                                    [_vm._v("> Traffic_Controller_Banksman: ")]
                                  ),
                                  _c(
                                    "b-col",
                                    { attrs: { sm: "7" } },
                                    [
                                      _c(
                                        "no-ssr",
                                        [
                                          _c("vue-ctk-date-time-picker", {
                                            attrs: {
                                              formatted: "DD-MM-YYYY",
                                              label: "Choose date",
                                              color: "#184167",
                                              "enable-button-validate": "",
                                              "disable-time": ""
                                            },
                                            model: {
                                              value:
                                                _vm.userEdited.workingProfile[
                                                  "Traffic_Controller_Banksman"
                                                ],
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.userEdited.workingProfile,
                                                  "Traffic_Controller_Banksman",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "userEdited.workingProfile['Traffic_Controller_Banksman']"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _c(
                                "b-row",
                                { staticClass: "user-edited-panel" },
                                [
                                  _c(
                                    "b-col",
                                    {
                                      staticClass: "text-align-right",
                                      attrs: { sm: "5" }
                                    },
                                    [_vm._v("> Confined_Space_awareness: ")]
                                  ),
                                  _c(
                                    "b-col",
                                    { attrs: { sm: "7" } },
                                    [
                                      _c(
                                        "no-ssr",
                                        [
                                          _c("vue-ctk-date-time-picker", {
                                            attrs: {
                                              formatted: "DD-MM-YYYY",
                                              label: "Choose date",
                                              color: "#184167",
                                              "enable-button-validate": "",
                                              "disable-time": ""
                                            },
                                            model: {
                                              value:
                                                _vm.userEdited.workingProfile[
                                                  "Confined_Space_awareness"
                                                ],
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.userEdited.workingProfile,
                                                  "Confined_Space_awareness",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "userEdited.workingProfile['Confined_Space_awareness']"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _c(
                                "b-row",
                                { staticClass: "user-edited-panel" },
                                [
                                  _c(
                                    "b-col",
                                    {
                                      staticClass: "text-align-right",
                                      attrs: { sm: "5" }
                                    },
                                    [_vm._v("> site_chemical_awareness: ")]
                                  ),
                                  _c(
                                    "b-col",
                                    { attrs: { sm: "7" } },
                                    [
                                      _c(
                                        "no-ssr",
                                        [
                                          _c("vue-ctk-date-time-picker", {
                                            attrs: {
                                              formatted: "DD-MM-YYYY",
                                              label: "Choose date",
                                              color: "#184167",
                                              "enable-button-validate": "",
                                              "disable-time": ""
                                            },
                                            model: {
                                              value:
                                                _vm.userEdited.workingProfile[
                                                  "site_chemical_awareness"
                                                ],
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.userEdited.workingProfile,
                                                  "site_chemical_awareness",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "userEdited.workingProfile['site_chemical_awareness']"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _c(
                                "b-row",
                                { staticClass: "user-edited-panel" },
                                [
                                  _c(
                                    "b-col",
                                    {
                                      staticClass: "text-align-right",
                                      attrs: { sm: "5" }
                                    },
                                    [_vm._v("> Site_LOTO: ")]
                                  ),
                                  _c(
                                    "b-col",
                                    { attrs: { sm: "7" } },
                                    [
                                      _c(
                                        "no-ssr",
                                        [
                                          _c("vue-ctk-date-time-picker", {
                                            attrs: {
                                              formatted: "DD-MM-YYYY",
                                              label: "Choose date",
                                              color: "#184167",
                                              "enable-button-validate": "",
                                              "disable-time": ""
                                            },
                                            model: {
                                              value:
                                                _vm.userEdited.workingProfile[
                                                  "Site_LOTO"
                                                ],
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.userEdited.workingProfile,
                                                  "Site_LOTO",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "userEdited.workingProfile['Site_LOTO']"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _c(
                                "b-row",
                                { staticClass: "user-edited-panel" },
                                [
                                  _c(
                                    "b-col",
                                    {
                                      staticClass: "text-align-right",
                                      attrs: { sm: "5" }
                                    },
                                    [_vm._v(" ECSOC_Expiry: ")]
                                  ),
                                  _c(
                                    "b-col",
                                    { attrs: { sm: "7" } },
                                    [
                                      _c(
                                        "no-ssr",
                                        [
                                          _c("vue-ctk-date-time-picker", {
                                            attrs: {
                                              formatted: "DD-MM-YYYY",
                                              label: "Choose date",
                                              color: "#184167",
                                              "enable-button-validate": "",
                                              "disable-time": ""
                                            },
                                            model: {
                                              value:
                                                _vm.userEdited.workingProfile[
                                                  "ECSOC_Expiry"
                                                ],
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.userEdited.workingProfile,
                                                  "ECSOC_Expiry",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "userEdited.workingProfile['ECSOC_Expiry']"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _c(
                                "b-row",
                                { staticClass: "user-edited-panel" },
                                [
                                  _c(
                                    "b-col",
                                    {
                                      staticClass: "text-align-right",
                                      attrs: { sm: "5" }
                                    },
                                    [_vm._v(" BCSS: ")]
                                  ),
                                  _c(
                                    "b-col",
                                    { attrs: { sm: "7" } },
                                    [
                                      _c(
                                        "no-ssr",
                                        [
                                          _c("vue-ctk-date-time-picker", {
                                            attrs: {
                                              formatted: "DD-MM-YYYY",
                                              label: "Choose date",
                                              color: "#184167",
                                              "enable-button-validate": "",
                                              "disable-time": ""
                                            },
                                            model: {
                                              value:
                                                _vm.userEdited.workingProfile[
                                                  "BCSS"
                                                ],
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.userEdited.workingProfile,
                                                  "BCSS",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "userEdited.workingProfile['BCSS']"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _c(
                                "b-row",
                                { staticClass: "user-edited-panel" },
                                [
                                  _c(
                                    "b-col",
                                    {
                                      staticClass: "text-align-right",
                                      attrs: { sm: "5" }
                                    },
                                    [_vm._v(" CSC_PM: ")]
                                  ),
                                  _c(
                                    "b-col",
                                    { attrs: { sm: "7" } },
                                    [
                                      _c(
                                        "no-ssr",
                                        [
                                          _c("vue-ctk-date-time-picker", {
                                            attrs: {
                                              formatted: "DD-MM-YYYY",
                                              label: "Choose date",
                                              color: "#184167",
                                              "enable-button-validate": "",
                                              "disable-time": ""
                                            },
                                            model: {
                                              value:
                                                _vm.userEdited.workingProfile[
                                                  "CSC_PM"
                                                ],
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.userEdited.workingProfile,
                                                  "CSC_PM",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "userEdited.workingProfile['CSC_PM']"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _c(
                                "b-row",
                                { staticClass: "user-edited-panel" },
                                [
                                  _c(
                                    "b-col",
                                    {
                                      staticClass: "text-align-right",
                                      attrs: { sm: "5" }
                                    },
                                    [
                                      _vm._v(
                                        " Safety_Officers_Training_Course_Specialist_Diploma: "
                                      )
                                    ]
                                  ),
                                  _c(
                                    "b-col",
                                    { attrs: { sm: "7" } },
                                    [
                                      _c(
                                        "no-ssr",
                                        [
                                          _c("vue-ctk-date-time-picker", {
                                            attrs: {
                                              formatted: "DD-MM-YYYY",
                                              label: "Choose date",
                                              color: "#184167",
                                              "enable-button-validate": "",
                                              "disable-time": ""
                                            },
                                            model: {
                                              value:
                                                _vm.userEdited.workingProfile[
                                                  "Safety_Officers_Training_Course_Specialist_Diploma"
                                                ],
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.userEdited.workingProfile,
                                                  "Safety_Officers_Training_Course_Specialist_Diploma",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "userEdited.workingProfile['Safety_Officers_Training_Course_Specialist_Diploma']"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _c(
                                "b-row",
                                { staticClass: "user-edited-panel" },
                                [
                                  _c(
                                    "b-col",
                                    {
                                      staticClass: "text-align-right",
                                      attrs: { sm: "5" }
                                    },
                                    [
                                      _vm._v(
                                        " Safety_Coordinator_Course_Advance_Cert: "
                                      )
                                    ]
                                  ),
                                  _c(
                                    "b-col",
                                    { attrs: { sm: "7" } },
                                    [
                                      _c(
                                        "no-ssr",
                                        [
                                          _c("vue-ctk-date-time-picker", {
                                            attrs: {
                                              formatted: "DD-MM-YYYY",
                                              label: "Choose date",
                                              color: "#184167",
                                              "enable-button-validate": "",
                                              "disable-time": ""
                                            },
                                            model: {
                                              value:
                                                _vm.userEdited.workingProfile[
                                                  "Safety_Coordinator_Course_Advance_Cert"
                                                ],
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.userEdited.workingProfile,
                                                  "Safety_Coordinator_Course_Advance_Cert",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "userEdited.workingProfile['Safety_Coordinator_Course_Advance_Cert']"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _c(
                                "b-row",
                                { staticClass: "user-edited-panel" },
                                [
                                  _c(
                                    "b-col",
                                    {
                                      staticClass: "text-align-right",
                                      attrs: { sm: "5" }
                                    },
                                    [
                                      _vm._v(
                                        " Risk_Management_Course_Bizsafe_Level_2: "
                                      )
                                    ]
                                  ),
                                  _c(
                                    "b-col",
                                    { attrs: { sm: "7" } },
                                    [
                                      _c(
                                        "no-ssr",
                                        [
                                          _c("vue-ctk-date-time-picker", {
                                            attrs: {
                                              formatted: "DD-MM-YYYY",
                                              label: "Choose date",
                                              color: "#184167",
                                              "enable-button-validate": "",
                                              "disable-time": ""
                                            },
                                            model: {
                                              value:
                                                _vm.userEdited.workingProfile[
                                                  "Risk_Management_Course_Bizsafe_Level_2"
                                                ],
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.userEdited.workingProfile,
                                                  "Risk_Management_Course_Bizsafe_Level_2",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "userEdited.workingProfile['Risk_Management_Course_Bizsafe_Level_2']"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _c(
                                "b-row",
                                { staticClass: "user-edited-panel" },
                                [
                                  _c(
                                    "b-col",
                                    {
                                      staticClass: "text-align-right",
                                      attrs: { sm: "5" }
                                    },
                                    [
                                      _vm._v(
                                        " Lifting_Supervisor_Safety_Course: "
                                      )
                                    ]
                                  ),
                                  _c(
                                    "b-col",
                                    { attrs: { sm: "7" } },
                                    [
                                      _c(
                                        "no-ssr",
                                        [
                                          _c("vue-ctk-date-time-picker", {
                                            attrs: {
                                              formatted: "DD-MM-YYYY",
                                              label: "Choose date",
                                              color: "#184167",
                                              "enable-button-validate": "",
                                              "disable-time": ""
                                            },
                                            model: {
                                              value:
                                                _vm.userEdited.workingProfile[
                                                  "Lifting_Supervisor_Safety_Course"
                                                ],
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.userEdited.workingProfile,
                                                  "Lifting_Supervisor_Safety_Course",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "userEdited.workingProfile['Lifting_Supervisor_Safety_Course']"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _c(
                                "b-row",
                                { staticClass: "user-edited-panel" },
                                [
                                  _c(
                                    "b-col",
                                    {
                                      staticClass: "text-align-right",
                                      attrs: { sm: "5" }
                                    },
                                    [_vm._v(" Rigger_Signalman: ")]
                                  ),
                                  _c(
                                    "b-col",
                                    { attrs: { sm: "7" } },
                                    [
                                      _c(
                                        "no-ssr",
                                        [
                                          _c("vue-ctk-date-time-picker", {
                                            attrs: {
                                              formatted: "DD-MM-YYYY",
                                              label: "Choose date",
                                              color: "#184167",
                                              "enable-button-validate": "",
                                              "disable-time": ""
                                            },
                                            model: {
                                              value:
                                                _vm.userEdited.workingProfile[
                                                  "Rigger_Signalman"
                                                ],
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.userEdited.workingProfile,
                                                  "Rigger_Signalman",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "userEdited.workingProfile['Rigger_Signalman']"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _c(
                                "b-row",
                                { staticClass: "user-edited-panel" },
                                [
                                  _c(
                                    "b-col",
                                    {
                                      staticClass: "text-align-right",
                                      attrs: { sm: "5" }
                                    },
                                    [
                                      _vm._v(
                                        " Metal_Scaffold_Erection_Course: "
                                      )
                                    ]
                                  ),
                                  _c(
                                    "b-col",
                                    { attrs: { sm: "7" } },
                                    [
                                      _c(
                                        "no-ssr",
                                        [
                                          _c("vue-ctk-date-time-picker", {
                                            attrs: {
                                              formatted: "DD-MM-YYYY",
                                              label: "Choose date",
                                              color: "#184167",
                                              "enable-button-validate": "",
                                              "disable-time": ""
                                            },
                                            model: {
                                              value:
                                                _vm.userEdited.workingProfile[
                                                  "Metal_Scaffold_Erection_Course"
                                                ],
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.userEdited.workingProfile,
                                                  "Metal_Scaffold_Erection_Course",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "userEdited.workingProfile['Metal_Scaffold_Erection_Course']"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _c(
                                "b-row",
                                { staticClass: "user-edited-panel" },
                                [
                                  _c(
                                    "b-col",
                                    {
                                      staticClass: "text-align-right",
                                      attrs: { sm: "5" }
                                    },
                                    [
                                      _vm._v(
                                        " Metal_Scaffold_Erection_Supervisor_Course: "
                                      )
                                    ]
                                  ),
                                  _c(
                                    "b-col",
                                    { attrs: { sm: "7" } },
                                    [
                                      _c(
                                        "no-ssr",
                                        [
                                          _c("vue-ctk-date-time-picker", {
                                            attrs: {
                                              formatted: "DD-MM-YYYY",
                                              label: "Choose date",
                                              color: "#184167",
                                              "enable-button-validate": "",
                                              "disable-time": ""
                                            },
                                            model: {
                                              value:
                                                _vm.userEdited.workingProfile[
                                                  "Metal_Scaffold_Erection_Supervisor_Course"
                                                ],
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.userEdited.workingProfile,
                                                  "Metal_Scaffold_Erection_Supervisor_Course",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "userEdited.workingProfile['Metal_Scaffold_Erection_Supervisor_Course']"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _c(
                                "b-row",
                                { staticClass: "user-edited-panel" },
                                [
                                  _c(
                                    "b-col",
                                    {
                                      staticClass: "text-align-right",
                                      attrs: { sm: "5" }
                                    },
                                    [_vm._v(" Mobile_Crane_Operator_Course: ")]
                                  ),
                                  _c(
                                    "b-col",
                                    { attrs: { sm: "7" } },
                                    [
                                      _c(
                                        "no-ssr",
                                        [
                                          _c("vue-ctk-date-time-picker", {
                                            attrs: {
                                              formatted: "DD-MM-YYYY",
                                              label: "Choose date",
                                              color: "#184167",
                                              "enable-button-validate": "",
                                              "disable-time": ""
                                            },
                                            model: {
                                              value:
                                                _vm.userEdited.workingProfile[
                                                  "Mobile_Crane_Operator_Course"
                                                ],
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.userEdited.workingProfile,
                                                  "Mobile_Crane_Operator_Course",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "userEdited.workingProfile['Mobile_Crane_Operator_Course']"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _c(
                                "b-row",
                                { staticClass: "user-edited-panel" },
                                [
                                  _c(
                                    "b-col",
                                    {
                                      staticClass: "text-align-right",
                                      attrs: { sm: "5" }
                                    },
                                    [_vm._v(" Crawler_Crane_Operator_Course: ")]
                                  ),
                                  _c(
                                    "b-col",
                                    { attrs: { sm: "7" } },
                                    [
                                      _c(
                                        "no-ssr",
                                        [
                                          _c("vue-ctk-date-time-picker", {
                                            attrs: {
                                              formatted: "DD-MM-YYYY",
                                              label: "Choose date",
                                              color: "#184167",
                                              "enable-button-validate": "",
                                              "disable-time": ""
                                            },
                                            model: {
                                              value:
                                                _vm.userEdited.workingProfile[
                                                  "Crawler_Crane_Operator_Course"
                                                ],
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.userEdited.workingProfile,
                                                  "Crawler_Crane_Operator_Course",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "userEdited.workingProfile['Crawler_Crane_Operator_Course']"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _c(
                                "b-row",
                                { staticClass: "user-edited-panel" },
                                [
                                  _c(
                                    "b-col",
                                    {
                                      staticClass: "text-align-right",
                                      attrs: { sm: "5" }
                                    },
                                    [_vm._v(" Lorry_Crane_Safety_Course: ")]
                                  ),
                                  _c(
                                    "b-col",
                                    { attrs: { sm: "7" } },
                                    [
                                      _c(
                                        "no-ssr",
                                        [
                                          _c("vue-ctk-date-time-picker", {
                                            attrs: {
                                              formatted: "DD-MM-YYYY",
                                              label: "Choose date",
                                              color: "#184167",
                                              "enable-button-validate": "",
                                              "disable-time": ""
                                            },
                                            model: {
                                              value:
                                                _vm.userEdited.workingProfile[
                                                  "Lorry_Crane_Safety_Course"
                                                ],
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.userEdited.workingProfile,
                                                  "Lorry_Crane_Safety_Course",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "userEdited.workingProfile['Lorry_Crane_Safety_Course']"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _c(
                                "b-row",
                                { staticClass: "user-edited-panel" },
                                [
                                  _c(
                                    "b-col",
                                    {
                                      staticClass: "text-align-right",
                                      attrs: { sm: "5" }
                                    },
                                    [
                                      _vm._v(
                                        " Hydraulic_Excavator_Operation_Course: "
                                      )
                                    ]
                                  ),
                                  _c(
                                    "b-col",
                                    { attrs: { sm: "7" } },
                                    [
                                      _c(
                                        "no-ssr",
                                        [
                                          _c("vue-ctk-date-time-picker", {
                                            attrs: {
                                              formatted: "DD-MM-YYYY",
                                              label: "Choose date",
                                              color: "#184167",
                                              "enable-button-validate": "",
                                              "disable-time": ""
                                            },
                                            model: {
                                              value:
                                                _vm.userEdited.workingProfile[
                                                  "Hydraulic_Excavator_Operation_Course"
                                                ],
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.userEdited.workingProfile,
                                                  "Hydraulic_Excavator_Operation_Course",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "userEdited.workingProfile['Hydraulic_Excavator_Operation_Course']"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _c(
                                "b-row",
                                { staticClass: "user-edited-panel" },
                                [
                                  _c(
                                    "b-col",
                                    {
                                      staticClass: "text-align-right",
                                      attrs: { sm: "5" }
                                    },
                                    [
                                      _vm._v(
                                        " Registered_Excavator_Operator_License: "
                                      )
                                    ]
                                  ),
                                  _c(
                                    "b-col",
                                    { attrs: { sm: "7" } },
                                    [
                                      _c(
                                        "no-ssr",
                                        [
                                          _c("vue-ctk-date-time-picker", {
                                            attrs: {
                                              formatted: "DD-MM-YYYY",
                                              label: "Choose date",
                                              color: "#184167",
                                              "enable-button-validate": "",
                                              "disable-time": ""
                                            },
                                            model: {
                                              value:
                                                _vm.userEdited.workingProfile[
                                                  "Registered_Excavator_Operator_License"
                                                ],
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.userEdited.workingProfile,
                                                  "Registered_Excavator_Operator_License",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "userEdited.workingProfile['Registered_Excavator_Operator_License']"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _c(
                                "b-row",
                                { staticClass: "user-edited-panel" },
                                [
                                  _c(
                                    "b-col",
                                    {
                                      staticClass: "text-align-right",
                                      attrs: { sm: "5" }
                                    },
                                    [
                                      _vm._v(
                                        " Confined_Space_Assessor_Course: "
                                      )
                                    ]
                                  ),
                                  _c(
                                    "b-col",
                                    { attrs: { sm: "7" } },
                                    [
                                      _c(
                                        "no-ssr",
                                        [
                                          _c("vue-ctk-date-time-picker", {
                                            attrs: {
                                              formatted: "DD-MM-YYYY",
                                              label: "Choose date",
                                              color: "#184167",
                                              "enable-button-validate": "",
                                              "disable-time": ""
                                            },
                                            model: {
                                              value:
                                                _vm.userEdited.workingProfile[
                                                  "Confined_Space_Assessor_Course"
                                                ],
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.userEdited.workingProfile,
                                                  "Confined_Space_Assessor_Course",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "userEdited.workingProfile['Confined_Space_Assessor_Course']"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _c(
                                "b-row",
                                { staticClass: "user-edited-panel" },
                                [
                                  _c(
                                    "b-col",
                                    {
                                      staticClass: "text-align-right",
                                      attrs: { sm: "5" }
                                    },
                                    [_vm._v("> IFWO_&_SIC: ")]
                                  ),
                                  _c(
                                    "b-col",
                                    { attrs: { sm: "7" } },
                                    [
                                      _c(
                                        "no-ssr",
                                        [
                                          _c("vue-ctk-date-time-picker", {
                                            attrs: {
                                              formatted: "DD-MM-YYYY",
                                              label: "Choose date",
                                              color: "#184167",
                                              "enable-button-validate": "",
                                              "disable-time": ""
                                            },
                                            model: {
                                              value:
                                                _vm.userEdited.workingProfile[
                                                  "IFWO_&_SIC"
                                                ],
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.userEdited.workingProfile,
                                                  "IFWO_&_SIC",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "userEdited.workingProfile['IFWO_&_SIC']"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _c(
                                "b-row",
                                { staticClass: "user-edited-panel" },
                                [
                                  _c(
                                    "b-col",
                                    {
                                      staticClass: "text-align-right",
                                      attrs: { sm: "5" }
                                    },
                                    [_vm._v("> SPA_&_SSK: ")]
                                  ),
                                  _c(
                                    "b-col",
                                    { attrs: { sm: "7" } },
                                    [
                                      _c(
                                        "no-ssr",
                                        [
                                          _c("vue-ctk-date-time-picker", {
                                            attrs: {
                                              formatted: "DD-MM-YYYY",
                                              label: "Choose date",
                                              color: "#184167",
                                              "enable-button-validate": "",
                                              "disable-time": ""
                                            },
                                            model: {
                                              value:
                                                _vm.userEdited.workingProfile[
                                                  "SPA_&_SSK"
                                                ],
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.userEdited.workingProfile,
                                                  "SPA_&_SSK",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "userEdited.workingProfile['SPA_&_SSK']"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _c(
                                "b-row",
                                { staticClass: "user-edited-panel" },
                                [
                                  _c(
                                    "b-col",
                                    {
                                      staticClass: "text-align-right",
                                      attrs: { sm: "5" }
                                    },
                                    [_vm._v("> SIFAPP1_&_2: ")]
                                  ),
                                  _c(
                                    "b-col",
                                    { attrs: { sm: "7" } },
                                    [
                                      _c(
                                        "no-ssr",
                                        [
                                          _c("vue-ctk-date-time-picker", {
                                            attrs: {
                                              formatted: "DD-MM-YYYY",
                                              label: "Choose date",
                                              color: "#184167",
                                              "enable-button-validate": "",
                                              "disable-time": ""
                                            },
                                            model: {
                                              value:
                                                _vm.userEdited.workingProfile[
                                                  "SIFAPP1_&_2"
                                                ],
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.userEdited.workingProfile,
                                                  "SIFAPP1_&_2",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "userEdited.workingProfile['SIFAPP1_&_2']"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _c(
                                "b-row",
                                { staticClass: "user-edited-panel" },
                                [
                                  _c(
                                    "b-col",
                                    {
                                      staticClass: "text-align-right",
                                      attrs: { sm: "5" }
                                    },
                                    [_vm._v("> SIFAPP3_LIFTING: ")]
                                  ),
                                  _c(
                                    "b-col",
                                    { attrs: { sm: "7" } },
                                    [
                                      _c(
                                        "no-ssr",
                                        [
                                          _c("vue-ctk-date-time-picker", {
                                            attrs: {
                                              formatted: "DD-MM-YYYY",
                                              label: "Choose date",
                                              color: "#184167",
                                              "enable-button-validate": "",
                                              "disable-time": ""
                                            },
                                            model: {
                                              value:
                                                _vm.userEdited.workingProfile[
                                                  "SIFAPP3_LIFTING"
                                                ],
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.userEdited.workingProfile,
                                                  "SIFAPP3_LIFTING",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "userEdited.workingProfile['SIFAPP3_LIFTING']"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _c(
                                "b-row",
                                { staticClass: "user-edited-panel" },
                                [
                                  _c(
                                    "b-col",
                                    {
                                      staticClass: "text-align-right",
                                      attrs: { sm: "5" }
                                    },
                                    [_vm._v("> SIFAPP4_CONFINEDSPACE: ")]
                                  ),
                                  _c(
                                    "b-col",
                                    { attrs: { sm: "7" } },
                                    [
                                      _c(
                                        "no-ssr",
                                        [
                                          _c("vue-ctk-date-time-picker", {
                                            attrs: {
                                              formatted: "DD-MM-YYYY",
                                              label: "Choose date",
                                              color: "#184167",
                                              "enable-button-validate": "",
                                              "disable-time": ""
                                            },
                                            model: {
                                              value:
                                                _vm.userEdited.workingProfile[
                                                  "SIFAPP4_CONFINEDSPACE"
                                                ],
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.userEdited.workingProfile,
                                                  "SIFAPP4_CONFINEDSPACE",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "userEdited.workingProfile['SIFAPP4_CONFINEDSPACE']"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _c(
                                "b-row",
                                { staticClass: "user-edited-panel" },
                                [
                                  _c(
                                    "b-col",
                                    {
                                      staticClass: "text-align-right",
                                      attrs: { sm: "5" }
                                    },
                                    [_vm._v("> CLEANROOM_PROTOCOL: ")]
                                  ),
                                  _c(
                                    "b-col",
                                    { attrs: { sm: "7" } },
                                    [
                                      _c(
                                        "no-ssr",
                                        [
                                          _c("vue-ctk-date-time-picker", {
                                            attrs: {
                                              formatted: "DD-MM-YYYY",
                                              label: "Choose date",
                                              color: "#184167",
                                              "enable-button-validate": "",
                                              "disable-time": ""
                                            },
                                            model: {
                                              value:
                                                _vm.userEdited.workingProfile[
                                                  "CLEANROOM_PROTOCOL"
                                                ],
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.userEdited.workingProfile,
                                                  "CLEANROOM_PROTOCOL",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "userEdited.workingProfile['CLEANROOM_PROTOCOL']"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _c(
                                "b-row",
                                { staticClass: "user-edited-panel" },
                                [
                                  _c(
                                    "b-col",
                                    {
                                      staticClass: "text-align-right",
                                      attrs: { sm: "5" }
                                    },
                                    [_vm._v("> BANKSMAN: ")]
                                  ),
                                  _c(
                                    "b-col",
                                    { attrs: { sm: "7" } },
                                    [
                                      _c(
                                        "no-ssr",
                                        [
                                          _c("vue-ctk-date-time-picker", {
                                            attrs: {
                                              formatted: "DD-MM-YYYY",
                                              label: "Choose date",
                                              color: "#184167",
                                              "enable-button-validate": "",
                                              "disable-time": ""
                                            },
                                            model: {
                                              value:
                                                _vm.userEdited.workingProfile[
                                                  "BANKSMAN"
                                                ],
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.userEdited.workingProfile,
                                                  "BANKSMAN",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "userEdited.workingProfile['BANKSMAN']"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _c(
                                "b-row",
                                { staticClass: "user-edited-panel" },
                                [
                                  _c(
                                    "b-col",
                                    {
                                      staticClass: "text-align-right",
                                      attrs: { sm: "5" }
                                    },
                                    [_vm._v(" FIRE_WATCHMAN: ")]
                                  ),
                                  _c(
                                    "b-col",
                                    { attrs: { sm: "7" } },
                                    [
                                      _c(
                                        "no-ssr",
                                        [
                                          _c("vue-ctk-date-time-picker", {
                                            attrs: {
                                              formatted: "DD-MM-YYYY",
                                              label: "Choose date",
                                              color: "#184167",
                                              "enable-button-validate": "",
                                              "disable-time": ""
                                            },
                                            model: {
                                              value:
                                                _vm.userEdited.workingProfile[
                                                  "FIRE_WATCHMAN"
                                                ],
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.userEdited.workingProfile,
                                                  "FIRE_WATCHMAN",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "userEdited.workingProfile['FIRE_WATCHMAN']"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _c(
                                "b-row",
                                { staticClass: "user-edited-panel" },
                                [
                                  _c(
                                    "b-col",
                                    {
                                      staticClass: "text-align-right",
                                      attrs: { sm: "5" }
                                    },
                                    [_vm._v(" SIC_ONLY_FAB_NEXT: ")]
                                  ),
                                  _c(
                                    "b-col",
                                    { attrs: { sm: "7" } },
                                    [
                                      _c(
                                        "no-ssr",
                                        [
                                          _c("vue-ctk-date-time-picker", {
                                            attrs: {
                                              formatted: "DD-MM-YYYY",
                                              label: "Choose date",
                                              color: "#184167",
                                              "enable-button-validate": "",
                                              "disable-time": ""
                                            },
                                            model: {
                                              value:
                                                _vm.userEdited.workingProfile[
                                                  "SIC_ONLY_FAB_NEXT"
                                                ],
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.userEdited.workingProfile,
                                                  "SIC_ONLY_FAB_NEXT",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "userEdited.workingProfile['SIC_ONLY_FAB_NEXT']"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _c(
                                "b-row",
                                { staticClass: "user-edited-panel" },
                                [
                                  _c(
                                    "b-col",
                                    {
                                      staticClass: "text-align-right",
                                      attrs: { sm: "5" }
                                    },
                                    [_vm._v(" LOTO_HEC: ")]
                                  ),
                                  _c(
                                    "b-col",
                                    { attrs: { sm: "7" } },
                                    [
                                      _c(
                                        "no-ssr",
                                        [
                                          _c("vue-ctk-date-time-picker", {
                                            attrs: {
                                              formatted: "DD-MM-YYYY",
                                              label: "Choose date",
                                              color: "#184167",
                                              "enable-button-validate": "",
                                              "disable-time": ""
                                            },
                                            model: {
                                              value:
                                                _vm.userEdited.workingProfile[
                                                  "LOTO_HEC"
                                                ],
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.userEdited.workingProfile,
                                                  "LOTO_HEC",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "userEdited.workingProfile['LOTO_HEC']"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _c("br"),
                              _c(
                                "b-row",
                                [
                                  _c(
                                    "b-col",
                                    { staticClass: "text-align-right" },
                                    [
                                      _c(
                                        "b-button",
                                        {
                                          attrs: {
                                            block: "",
                                            variant: "success",
                                            size: "lg"
                                          },
                                          on: {
                                            click: function($event) {
                                              _vm.editWorkingProfile()
                                            }
                                          }
                                        },
                                        [_vm._v("Update Working Profile")]
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _c("br")
                            ],
                            1
                          )
                        : _vm._e()
                    ]
                  ),
                  _c("br"),
                  _c(
                    "b-card",
                    {
                      attrs: {
                        "border-variant": "dark",
                        header: "Booking History",
                        "header-bg-variant": "info",
                        "header-text-variant": "white"
                      }
                    },
                    [
                      !!_vm.userEditedBookedModuleSession
                        ? _c(
                            "div",
                            { attrs: { role: "tablist" } },
                            _vm._l(_vm.userEditedBookedModuleSession, function(
                              item,
                              index
                            ) {
                              return _c(
                                "b-card",
                                {
                                  key: "bookedModule" + index,
                                  staticClass: "mb-1",
                                  attrs: { "no-body": "" }
                                },
                                [
                                  _c(
                                    "b-card-header",
                                    [
                                      _vm.$store.state.authUser.flag !==
                                        "Admin" &&
                                      Number(item.sessionTime) -
                                        Number(_vm.$moment().format("X")) <=
                                        3600 * 24 * 3
                                        ? _c(
                                            "b-btn",
                                            {
                                              attrs: {
                                                block: "",
                                                disabled: "",
                                                variant: "outline-info"
                                              },
                                              on: {
                                                click: function($event) {
                                                  _vm.expandAccordion(item.id)
                                                }
                                              }
                                            },
                                            [
                                              _vm._v(
                                                "\n                                    " +
                                                  _vm._s(item.moduleName) +
                                                  " | " +
                                                  _vm._s(
                                                    _vm
                                                      .$moment(
                                                        item.sessionTime,
                                                        "X"
                                                      )
                                                      .format("LLLL")
                                                  ) +
                                                  " | " +
                                                  _vm._s(item.language) +
                                                  " | Room:" +
                                                  _vm._s(item.roomId) +
                                                  "\n                                "
                                              )
                                            ]
                                          )
                                        : _c(
                                            "b-btn",
                                            {
                                              attrs: {
                                                block: "",
                                                variant: "outline-info"
                                              },
                                              on: {
                                                click: function($event) {
                                                  _vm.expandAccordion(item.id)
                                                }
                                              }
                                            },
                                            [
                                              _vm._v(
                                                "\n                                    " +
                                                  _vm._s(item.moduleName) +
                                                  " | " +
                                                  _vm._s(
                                                    _vm
                                                      .$moment(
                                                        item.sessionTime,
                                                        "X"
                                                      )
                                                      .format("LLLL")
                                                  ) +
                                                  " | " +
                                                  _vm._s(item.language) +
                                                  " | Room:" +
                                                  _vm._s(item.roomId) +
                                                  "\n                                "
                                              )
                                            ]
                                          )
                                    ],
                                    1
                                  ),
                                  _c(
                                    "b-collapse",
                                    {
                                      attrs: {
                                        id: item.id,
                                        accordion: "user-edited-accordion",
                                        role: "tab-panel"
                                      }
                                    },
                                    [
                                      _c(
                                        "b-card-body",
                                        [
                                          _vm._v(
                                            "\n                                    Module Name: " +
                                              _vm._s(item.moduleName) +
                                              " "
                                          ),
                                          _c("br"),
                                          _vm._v(
                                            "\n                                    Session Time: " +
                                              _vm._s(
                                                _vm
                                                  .$moment(
                                                    item.sessionTime,
                                                    "X"
                                                  )
                                                  .format("LLLL")
                                              ) +
                                              " "
                                          ),
                                          _c("br"),
                                          _vm._v(
                                            "\n                                    Language: " +
                                              _vm._s(item.language) +
                                              " "
                                          ),
                                          _c("br"),
                                          _vm._v(
                                            "\n                                    Room: " +
                                              _vm._s(item.roomId) +
                                              "\n                                    "
                                          ),
                                          _vm.$store.state.authUser.flag !=
                                            "Admin" &&
                                          Number(item.sessionTime).format("X") -
                                            Number(
                                              _vm.$moment().format("X") >=
                                                3600 * 24 * 3
                                            )
                                            ? _c(
                                                "b-btn",
                                                {
                                                  attrs: {
                                                    block: "",
                                                    variant: "danger"
                                                  },
                                                  on: {
                                                    click: function($event) {
                                                      _vm.cancelBooking(item.id)
                                                    }
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                                        CANCEL BOOKING\n                                    "
                                                  )
                                                ]
                                              )
                                            : _c(
                                                "b-btn",
                                                {
                                                  attrs: {
                                                    block: "",
                                                    disabled: "",
                                                    variant: "primary"
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                                        CANCEL BOOKING\n                                    "
                                                  )
                                                ]
                                              )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            })
                          )
                        : _vm._e()
                    ]
                  )
                ],
                1
              )
            ],
            2
          )
        ],
        1
      ),
      _c(
        "b-modal",
        {
          ref: "remove-user" + _vm.userEdited.nricFin,
          attrs: {
            id: "removeCurrentUserModal",
            "hide-footer": "",
            size: "lg",
            title: _vm.removingModalTitle
          }
        },
        [
          _c(
            "b-container",
            { attrs: { fluid: "" } },
            [
              _c("b-form-input", {
                attrs: { placeholder: "enter user nric/fin to confirm" },
                model: {
                  value: _vm.removingNricFin,
                  callback: function($$v) {
                    _vm.removingNricFin = $$v
                  },
                  expression: "removingNricFin"
                }
              }),
              _c(
                "b-btn",
                {
                  staticClass: "mt-3",
                  attrs: { size: "lg", variant: "outline-danger", block: "" },
                  on: {
                    click: function($event) {
                      _vm.removeUser()
                    }
                  }
                },
                [_vm._v("\n                confirm remove user\n            ")]
              )
            ],
            1
          )
        ],
        1
      ),
      _c("p", [_vm._v("edit user page")])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7fbfe33a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7fbfe33a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./pages/dashboard/registration/_userId.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-7fbfe33a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./pages/dashboard/registration/_userId.vue
// module chunks = 14